import { useQuery, type UseQueryOptions } from '@tanstack/react-query'

import type { RetrofitFinancingResult } from '@/shared/types/retrofit-financing.types'

import { retrofitFinancingApi } from './retrofit-financing.api'

/**
 * Query key factory for retrofit financing queries
 */
export const retrofitFinancingKeys = {
  all: ['retrofit-financing'] as const,
  byBuilding: (buildingId: string) =>
    [...retrofitFinancingKeys.all, 'building', buildingId] as const,
}

/**
 * Hook to fetch retrofit financing data for a specific building
 * @param buildingId - The UUID of the building
 * @param options - Optional React Query options
 */
export const useRetrofitFinancing = (
  buildingId: string | undefined,
  options?: Omit<UseQueryOptions<RetrofitFinancingResult[], Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<RetrofitFinancingResult[], Error>({
    queryKey: retrofitFinancingKeys.byBuilding(buildingId!),
    queryFn: () => retrofitFinancingApi.getRetrofitFinancing(buildingId!),
    ...options,
    enabled: !!buildingId && options?.enabled !== false,
  })
}
